import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import KPMonthYearPicker from "../../../components/KPMonthYearPicker";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";

import { uploadFile, uploadMultiFile } from "../../../reducer/file/action";
import { insertPresentation, updatePresentation } from "../../../reducer/presentation/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { getAllEmploymentContractByProfileId } from "../../../reducer/employmentContract/action";

import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";
import { set } from "immutable";
import { DropzoneArea } from "material-ui-dropzone";
import { KPTextfield } from "components/KPTComponents";
import { file } from "jszip";

function PresentationInsertModal(props) {
  const { inserting, setInserting } = props;

  const dispatch = useDispatch();
  const [values, setValues] = useState({ purposeId: 5, type: "interview_article" });
  const [detail, setDetail] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [timeResearchYear, setTimeResearchYear] = useState(0);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [helperTextGiayPhep, setHelperTextGiayPhep] = useState(false);
  const [helperTextTaiBan, setHelperTextTaiBan] = useState(false);

  const profileDetail = useSelector((state) => select(state, "profileReducer", "detail"));

  // Tự gán bản thân vào danh sách tác giả
  React.useEffect(() => {
    if (inserting) {
      // Reset newFiles khi mở modal mới
      setNewFiles([]);
    }
    if (props.profile?.id && profileList.length === 0) {
      setProfileList([
        {
          profileId: props.profile.id,
          roleInPresentation: "main",
          statusInProject: "K",
          isInternal: true,
          externalName: "",
        },
      ]);
    }
  }, [inserting, props.profile?.id]);

  React.useEffect(() => {
    if (values?.type) setHelperText(false);
  }, [values?.type]);

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else setValues({ ...values, [name]: value });
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInPresentation: "member",
      statusInProject: "K",
      isInternal: true,
      externalName: "",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const insertPresentation = async (uploadedUrls) => {
    const d = new Date();
    const tempListMember = values?.listMember?.split(",").map((author) => author.trimStart());
    let result = await props
      .insertPresentation(props.profile?.id, {
        ...values,
        listMember: tempListMember,
        dashboardYear: values?.year,
        presentationProfile: profileList,
        fileUrl: uploadedUrls,
      })
      .then((response) => {
        if (response.success) {
          props.statisticUnaccepted({
            departmentId: 0,
            profileId: props.profile?.id,
          });
          if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
        }
        return response.success;
      });
  };

  const handleSubmit = async (e) => {
    // check title, numOfMember, type
    if (!values?.title || !values?.type || !values?.acceptedMonth || !values?.acceptedYear) {
      setHelperText(true);
      return;
    }

    // Upload new files if any
    let uploadedUrls = "";
    if (newFiles.length > 0) {
      const uploadResult = await dispatch(uploadMultiFile(profileDetail?.id, newFiles, "presentation"));
      if (uploadResult.success) {
        uploadedUrls = uploadResult.data.join("||");
      }
    }

    const success = await insertPresentation(uploadedUrls);
    if (success) {
      setValues(null);
      setProfileList([]);
      setNewFiles([]);
      setInserting(false);
    }
  };

  const handleClose = () => {
    setValues(null);
    setProfileList([]);
    setNewFiles([]);
    setInserting(false);
  };

  const profileListFromProps = [{ id: -1, name: "" }];
  props.profileList.forEach((e) => profileListFromProps.push(e));

  // Filter timeResearchDetailList without year filtering
  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0) {
      // Get all timeResearchDetail from all years and filter by type
      let allDetails = [];
      props.timeResearchInformationList.forEach((yearData) => {
        if (yearData.timeResearchDetail) {
          allDetails = [...allDetails, ...yearData.timeResearchDetail];
        }
      });

      let list = allDetails.filter((e) => !e.allowedUpdateNum && e.type === "presentation");
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
        timeResearchDetailCode: null,
      });
    }
  }, [props.timeResearchInformationList]);

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  // const yearList = [];
  // // console.log(props.timeResearchInformationList);
  // props.timeResearchInformationList
  //   .sort((a, b) => b.year - a.year)
  //   .forEach((e) => {
  //     yearList.push(e.year);
  //   });

  const _note = useMemo(() => {
    let note = "";
    if (values?.type === "interview_article") {
      note = `Bài viết/hình ảnh phát sóng`;
    }
    if (
      values?.type === "international_seminar_paper" ||
      values?.type === "national_seminar_paper" ||
      values?.type === "keynote_international_seminar"
    ) {
      note = `Upload file Scan bản gốc:
1. Bìa
2. Mục lục có tên tác giả
3. Trang đầu của bài viết
4. Trang có đăng ký số giấy phép xuất bản hoặc số ISSN
5. Đường link. Nếu bài báo không có đường link phải cung cấp đủ các minh chứng trên và toàn bộ bản mềm của bài báo
Ghi chú:
- Việc kê khai công trình phải ghi đầy đủ tên bài báo/bài hội thảo, từ trang bao nhiêu trong tạp chí/kỷ yếu.
- Tác giả chính nếu không có xác nhận của BBT hoặc quy định của Tạp chí thì được hiểu là corresponding author hoặc tác giả đứng đầu.

`;
    }
    if (values?.type === "departmental_scientific_activities") {
      note = `- Scan Biên bản, Slide/báo cáo
- Xác nhận đơn vị`;
    }
    if (
      values?.type === "international_seminar_without_proceedings" ||
      values?.type === "national_seminar_with_proceedings" ||
      values?.type === "scientific_presentation_by_order"
    ) {
      note = `Upload file Scan bản gốc:
1. Bìa
2. Mục lục có tên tác giả
3. Trang đầu của bài viết
4. Trang có đăng ký số giấy phép xuất bản hoặc số ISSN
5. Đường link. Nếu bài báo không có đường link phải cung cấp đủ các minh chứng trên và toàn bộ bản mềm của bài báo
Ghi chú:
- Việc kê khai công trình phải ghi đầy đủ tên bài báo/bài hội thảo, từ trang bao nhiêu trong tạp chí/kỷ yếu.
- Tác giả chính nếu không có xác nhận của BBT hoặc quy định của Tạp chí thì được hiểu là corresponding author hoặc tác giả đứng đầu.
`;
    }
    return note;
  }, [values?.type]);

  const getNoteByType = () => {
    return _note;
  };

  // Thêm mặc định cho tôi acceptedMonth và acceptedYear là tháng/năm hiện tại
  useEffect(() => {
    if (inserting) {
      const currentDate = new Date();
      setValues((prevValues) => ({
        ...(prevValues || { purposeId: 5, type: "interview_article" }),
        acceptedDay: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1, 12, 0, 0), // Ngày 1 của tháng hiện tại, giờ 12:00 để tránh lệch múi giờ
        acceptedMonth: currentDate.getMonth() + 1,
        acceptedYear: currentDate.getFullYear(),
      }));
    }
  }, [inserting]);

  return (
    <Dialog
      fullWidth
      keepMounted
      maxWidth={false}
      open={inserting}
      onClose={() => setInserting(false)}
      disableBackdropClick
      PaperProps={{
        style: {
          width: "calc(100vw - 240px)",
          height: "100vh",
          maxWidth: "calc(100vw - 240px)",
          maxHeight: "100vh",
          margin: "0 0 0 240px",
        },
      }}
    >
      <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 32px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography variant="h5" style={{ fontWeight: 600, marginRight: 24 }}>
          Thêm bài trình bày, truyền thông, phỏng vấn, truyền hình
        </Typography>
        <div style={{ display: "flex", gap: "12px" }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => handleClose()}
            style={{
              padding: "8px 24px",
              fontSize: "15px",
              fontWeight: 500,
              borderWidth: 2,
            }}
          >
            Huỷ
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit()}
            // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
            disabled={false}
            style={{
              padding: "8px 24px",
              fontSize: "15px",
              fontWeight: 600,
              boxShadow: "0 2px 8px rgba(63, 81, 181, 0.3)",
            }}
          >
            Xác nhận
          </Button>
        </div>
      </DialogTitle>
      <DialogContent style={{ flex: 1, overflow: "hidden", display: "flex", padding: 0 }}>
        <div
          style={{
            width: "60%",
            padding: "16px 24px",
            overflowY: "auto",
            borderRight: "1px solid #e0e0e0",
          }}
        >
          <Grid container justifyContent="flex-start" spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Tên công trình"
                variant="outlined"
                value={values?.title?.toString() || ""}
                required
                error={helperText && !values?.title}
                helperText={helperText && !values?.title ? "Vui lòng nhập tên sách/ tiêu đề" : ""}
                onChange={(event) => handleChangeForm("title", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                size="small"
                label="Loại công trình"
                variant="outlined"
                value={values?.timeResearchDetailCode || null}
                onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                InputLabelProps={{
                  shrink: !(values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null),
                }}
                // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
                error={false}
              >
                {timeResearchDetailList.length > 0 ? (
                  timeResearchDetailList?.map((e) => (
                    <MenuItem key={e.code} value={e.code}>
                      {e.description}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value={null} disabled>
                    Chưa có dữ liệu
                  </MenuItem>
                )}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Tên hội nghị/ hội thảo"
                value={values?.conferenceName || ""}
                error={helperText && !values?.conferenceName}
                helperText={helperText && !values?.conferenceName ? "Vui lòng nhập tên hội nghị/ hội thảo" : ""}
                onChange={(event) => handleChangeForm("conferenceName", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Tên tạp chí"
                value={values?.journalName || ""}
                onChange={(event) => handleChangeForm("journalName", event.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <KPMonthYearPicker
                fullWidth
                label="Tháng/Năm công bố"
                required
                value={values?.acceptedDay}
                setValue={(newValue) => {
                  // newValue có dạng "01/mm/yyyy"
                  const parts = newValue.split("/");
                  if (parts.length === 3) {
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10);
                    const year = parseInt(parts[2], 10);

                    // Lưu acceptedMonth
                    handleChangeForm("acceptedMonth", month);

                    // Lưu acceptedDay là Date object với ngày 1 của tháng đó, giờ 12:00 để tránh lệch múi giờ
                    const date = new Date(year, month - 1, day, 12, 0, 0);
                    handleChangeForm("acceptedDay", date);
                  }
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <KPMonthYearPicker
                fullWidth
                label="Tháng/Năm xuất bản"
                value={values?.publishedDay}
                setValue={(newValue) => {
                  // newValue có dạng "01/mm/yyyy"
                  const parts = newValue.split("/");
                  if (parts.length === 3) {
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10);
                    const year = parseInt(parts[2], 10);

                    // Lưu publishedMonth
                    handleChangeForm("publishedMonth", month);

                    // Lưu publishedDay là Date object với ngày 1 của tháng đó, giờ 12:00 để tránh lệch múi giờ
                    const date = new Date(year, month - 1, day, 12, 0, 0);
                    handleChangeForm("publishedDay", date);
                  }
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                label="Số ISBN"
                variant="outlined"
                value={values?.isbn || ""}
                onChange={(event) => handleChangeForm("isbn", event.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Mục đích
                </InputLabel>
                <Select
                  native
                  fullWidth
                  labelId="purpose-label"
                  value={values?.purposeId ?? "none"}
                  onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                >
                  {props.purposes.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.description}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Link"
                value={values?.link || ""}
                onChange={(event) => handleChangeForm("link", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Đơn vị tổ chức"
                variant="outlined"
                value={values?.organizingUnit || ""}
                // multiline
                // rows={3}
                onChange={(event) => handleChangeForm("organizingUnit", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Địa điểm tổ chức"
                variant="outlined"
                value={values?.organizingPlace || ""}
                // multiline
                // rows={3}
                onChange={(event) => handleChangeForm("organizingPlace", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Tóm tắt"
                variant="outlined"
                value={values?.abstract || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("abstract", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  <Grid item xs={1}>
                    {/* Check box default is checked với text "nội bộ" */}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={e.isInternal !== false}
                          onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Nội bộ"
                    />
                  </Grid>
                  {e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 4}>
                      <Autocomplete
                        disableClearable
                        options={props.profileList}
                        getOptionLabel={(option) => option.name}
                        value={
                          profileListFromProps?.find((profile) => profile.id === e.profileId) || profileListFromProps[0]
                        }
                        onChange={(event, profile) => {
                          if (profileList[index]?.profileId === values?.profileIdForKpi)
                            handleChangeForm("profileIdForKpi", null);
                          handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                        }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                        )}
                      />
                    </Grid>
                  )}
                  {!e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 4}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Tên thành viên"
                        value={e?.externalName || ""}
                        onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                      />
                      {helperText && e.externalName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}
                  {e.isInternal && (
                    <>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          disabled
                          variant="outlined"
                          label="Mã viên chức"
                          value={profileListFromProps?.find((profile) => profile.id === e.profileId)?.code || ""}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          disabled
                          variant="outlined"
                          label="Đơn vị"
                          value={
                            profileListFromProps?.find((profile) => profile.id === e.profileId)?.departmentProfile?.[0]
                              ?.department?.name || ""
                          }
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 3 : 2}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="roleInPresentation-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Vai trò được giao
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId="roleInPresentation-label"
                        value={e?.roleInPresentation || "main"}
                        onChange={(event) => handleChangeProfileList(index, "roleInPresentation", event.target.value)}
                      >
                        <option value="main">Tác giả</option>
                        <option value="member">Đồng tác giả</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  {values?.purposeId === 1 && (
                    <Grid item xs={2}>
                      <FormControl required fullWidth error={!values?.profileIdForKpi}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForKpi",
                              values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính KPI
                        </Button>
                        {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  {values?.purposeId === 99999999 && (
                    <Grid item xs={2}>
                      <FormControl required fullWidth error={!values?.profileIdForReward}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForReward === "number" &&
                            values?.profileIdForReward === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            handleChangeForm(
                              "profileIdForReward",
                              values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính thưởng
                        </Button>
                        {!values?.profileIdForReward && <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={2}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="statusInProject-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Trạng thái
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId="statusInProject-label"
                        value={e?.statusInProject || "K"}
                        onChange={(event) => handleChangeProfileList(index, "statusInProject", event.target.value)}
                      >
                        <option value="NCS">Đang làm NCS</option>
                        <option value="CH">Đang học Cao học</option>
                        <option value="K">Khác</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12}>
              <Button fullWidth variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            flexDirection: "column",
            display: values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "block" : "none",
          }}
        >
          <EmploymentContractTable
            contract={detail}
            contractList={contractList}
            kpiIdForKpi={values?.kpiIdForKpi}
            contractIdForKpi={values?.contractIdForKpi}
            setDetail={setDetail}
            values={values}
            setValues={setValues}
            handleChangeForm={handleChangeForm}
          />
          <EmploymentContractDetailTable kpi={detail} />
        </div>
        <div
          style={{
            width: "40%",
            padding: "16px 24px",
            overflowY: "auto",
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="h6" style={{ marginBottom: 16 }}>
            Upload file minh chứng
          </Typography>
          <div
            style={{
              backgroundColor: "#ffebee",
              color: "#c62828",
              padding: "12px",
              marginBottom: 16,
              borderRadius: 4,
              whiteSpace: "pre-line",
            }}
          >
            {getNoteByType()}
          </div>
          <MultiFileManager
            fileUrls={[]}
            setFileUrls={() => {}}
            newFiles={newFiles}
            setNewFiles={setNewFiles}
            disabled={false}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  profileList: select(state, "profileReducer", "list"),
  listById: select(state, "presentationReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
});

const mapDispatchToProps = (dispatch) => ({
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  insertPresentation: (profileId, payload) => dispatch(insertPresentation(profileId, payload)),
  updatePresentation: (profileId, payload) => dispatch(updatePresentation(profileId, payload)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(PresentationInsertModal));

